<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>发电量</div>
            <div>
                <a-select class="station-type" v-model="type"  defaultValue="0"   @change="handleChange" :getPopupContainer="
                                  triggerNode => {
                                    return triggerNode.parentNode || document.body;
                                  }
                                ">
                    <a-select-option value="3">当日</a-select-option>
                    <a-select-option value="2">当月</a-select-option>
                    <a-select-option value="1">当年</a-select-option>
                    <a-select-option value="4">累计</a-select-option>
                </a-select>
            </div>
        </div>
        <div class="base-panel-body vertical-center">
            <template v-if="data.XTime.length > 0">
                <basic-echarts ref="inverterElectorPowerChart" :height="'100%'"></basic-echarts>
            </template>
            <template v-else-if="data.XTime.length === 0">
                <a-empty style="padding-top: 30px" />
            </template>
        </div>
    </div>
</template>

<script>
    import BasicEcharts from "@/components/Echarts/BasicEcharts";
    export default {
        name: "inverterElectorPower",
        components:{
            BasicEcharts
        },
        data(){
            return {
                inverterId: 0,
                type: '1',
                typeList:{
                        "1": '月',
                        "2": '日',
                        "3": '时',
                        "4": '年'
                },
                data:{
                    XTime:[],
                    YPower:[],
                    YRadiation:[],
                    YPR:[]
                }
            }
        },

        methods:{
            initCharts(id){
                this.inverterId = id;
                this.loadCharts();
            },
            async loadCharts(){
                 let result = await this.$http.get(this.$baseURL.inverterGenerate({inverterId: this.inverterId, timeDimension: this.type}));
                 console.log(result);

                this.data.XTime = [];
                this.data.YPower = [];
                this.data.YRadiation = [];
                this.data.YPR = [];

                if(result.length > 0){
                    result.forEach(item => {
                        this.data.XTime.push(item.timeInterval);
                        this.data.YPower.push(item.elecCap.toFixed(2));
                        this.data.YRadiation.push(item.elecHour.toFixed(2));
                        this.data.YPR.push(item.avgPR.toFixed(2));
                    });


                    let option = {
                        tooltip : {
                            trigger: 'axis',
                            formatter: (data)=> {
                                let html = '';
                                data.forEach((item, index ) => {
                                    if(index === 0){
                                        html += item.axisValueLabel + this.typeList[this.type];
                                    }

                                    html += '<br>' + item.marker + item.seriesName + ': ' + Number(item.value);
                                    if(item.seriesName === '发电量'){
                                        html += 'kWh';
                                    } else if(item.seriesName === '发电小时'){
                                        html += 'h';
                                    } else if(item.seriesName === '平均PR'){
                                        html += '%';
                                    }

                                });
                                //console.log(data)
                                return html;
                            }
                        },
                        legend: {
                            data:['发电量','发电小时','平均PR']
                        },
                        toolbox: {
                            show : false,
                            feature : {
                                mark : {show: true},
                                dataView : {show: true, readOnly: false},
                                magicType : {show: true, type: ['line', 'bar']},
                                restore : {show: true},
                                saveAsImage : {show: true}
                            }
                        },
                        calculable : false,
                        grid:{
                            top: '10%'
                        },
                        xAxis : [
                            {
                                type : 'category',
                                data : this.data.XTime
                            }
                        ],
                        yAxis : [
                            {
                                type : 'value',
                                position: 'left',
                                name:"kWh",
                                axisLabel : {
                                    show:true,
                                    interval: 'auto'    // {number}
                                },
                                splitLine : {
                                    show: true,
                                    color: ['#ccc'],
                                    width: 1,
                                    type: 'dotted'
                                }
                            },
                            {
                                type : 'value',
                                position: 'top',
                                name:"%",
                                axisLabel : {
                                    show:true,
                                    interval: 'auto',    // {number}
                                    /*  formatter: '{value} h'*/
                                },
                                splitLine : {
                                    show: true,
                                    color: ['#ccc'],
                                    width: 1,
                                    type: 'dotted'
                                }
                            }
                        ],
                        series : [
                            {
                                name:'发电量',
                                type:'bar',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                data: this.data.YPower
                            },
                            {
                                name:'发电小时',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                data: this.data.YRadiation

                            },
                            {
                                name:'平均PR',
                                type:'line',
                                yAxisIndex:1,
                                data: this.data.YPR
                            }
                        ]
                    }

                    this.$nextTick(()=>{
                        this.$refs.inverterElectorPowerChart.refresh(option);
                    })


                }


            },
            handleChange(){
                this.loadCharts();
            }
        }
    }
</script>

<style scoped>

</style>
